var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuFashion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 20.8333C5.83337 13.0093 12.176 6.66663 20 6.66663V6.66663C27.8241 6.66663 34.1667 13.0093 34.1667 20.8333V21.1594C34.1667 22.36 33.1934 23.3333 31.9928 23.3333H8.00729C6.80667 23.3333 5.83337 22.36 5.83337 21.1594V20.8333Z",
    fill: "#5C5B5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 15.8333C10.8334 10.7707 14.9374 6.66663 20 6.66663V6.66663C25.0627 6.66663 29.1667 10.7707 29.1667 15.8333V30.8333C29.1667 32.214 28.0474 33.3333 26.6667 33.3333H13.3334C11.9527 33.3333 10.8334 32.214 10.8334 30.8333V15.8333Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 30,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.66663C12.176 6.66663 5.83337 13.0093 5.83337 20.8333V21.1594C5.83337 22.36 6.80667 23.3333 8.00729 23.3333H10.8334V33.3333H29.1667V23.3333H31.9928C33.1934 23.3333 34.1667 22.36 34.1667 21.1594V20.8333C34.1667 13.0093 27.8241 6.66663 20 6.66663Z",
    fill: "url(#paint0_linear_1451_18070)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7695 6.66663H13.0761C12.4423 6.66663 12.0405 7.34618 12.346 7.90156L15.6677 13.941C15.9489 14.4523 16.6549 14.5237 17.0328 14.0791L22.1663 8.03967C22.6264 7.49843 22.2417 6.66663 21.5314 6.66663H15.7695Z",
    fill: "#FF791C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3578 6.66663H27.6404C28.2997 6.66663 28.6979 7.396 28.3413 7.95059L24.4149 14.0584C24.1131 14.5278 23.4443 14.5738 23.0812 14.1501L17.8459 8.04229C17.3825 7.50172 17.7666 6.66663 18.4786 6.66663H24.3578Z",
    fill: "#FF791C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1451_18070",
    x1: 17.0834,
    y1: 9.16663,
    x2: 32.0861,
    y2: 18.6432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75C3B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuFashion);
export default __webpack_public_path__ + "static/media/wikiMenuFashion.d30f637fa7caefbda3b02c380b640365.svg";
export { ForwardRef as ReactComponent };